// ANIMUS scroll-reveal v2 — IntersectionObserver para sections debajo del fold
// v2: selector ampliado para cubrir todas las sections animus con reveal dependency
(function() {
  var SEL = '.animus-strip, .animus-tagline-strip, .animus-tagline, .animus-colorways, .animus-craft, .animus-manifest, .animus-pdp-craft, .animus-pdp-craft-evidence, .animus-chromatic, .animus-reframe';
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll(SEL).forEach(function(el) { el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
  document.querySelectorAll(SEL).forEach(function(el) { io.observe(el); });
  // Fallback de seguridad: si algo queda sin revelar tras 2.5s, forzar visible (anti-blank-section)
  setTimeout(function() {
    document.querySelectorAll(SEL).forEach(function(el) {
      if (!el.classList.contains('is-visible')) el.classList.add('is-visible');
    });
  }, 2500);
})();
